import {useNavigate} from 'react-router-dom';
import styles from './header.module.scss';

type THeaderProps = {
  title: string;
  route?: string;
  showBackBtn? : boolean
};

const Header = ({title, route , showBackBtn =true}: THeaderProps) => {
  const navigate = useNavigate();
  return (
    <>
      <div className={styles.header}>
        <div className="row align-items-center h-100 color-gray-1">
          <div className="col-1">
            {showBackBtn && <i
              className="icon-arrow-right1 fs-1"
              onClick={() => (route ? navigate(route) : navigate(-1))}
            ></i> }          
          </div>
          <div className="col-10 text-center">
            <span className="flex-1">{title}</span>
          </div>
          <div className="col-1"></div>
        </div>
      </div>
    </>
  );
};

export default Header;
